export const formatMessage = ({ message, from, to }) => {
  return `From: ${from}\nTo: ${to}\n\nMessage: ${message}`;
};
